
import { defineComponent } from 'vue'
import hemisphereService from '@/services/hemisphere.service'
import useVuelidate from '@vuelidate/core'
import { sameAs } from '@vuelidate/validators'
import { required, withI18nMessage } from '@/utils/i18n-validators'
import { useSession } from '@/composables/auth'

export default defineComponent({
  setup() {
    let { user } = useSession()
    return {
      v$: useVuelidate(),
      user
    }
  },
  data() {
    return {
      dialogVisible: false,
      oldPassword: '',
      newPassword: '',
      newPasswordConfirm: '',
      passwordChanged: false,
      invalidPassword: undefined as string | undefined
    }
  },
  validations() {
    return {
      invalidPassword: {},
      oldPassword: {
        required,
        not_current_password: withI18nMessage((value: string) => this.invalidPassword != value)
      },
      newPassword: {
        required,
        password_should_differ: withI18nMessage((value: string) => this.oldPassword != value)
      },
      newPasswordConfirm: {
        required,
        password_confirm_match: withI18nMessage(sameAs(this.newPassword))
      }
    }
  },
  computed: {
    closable(): boolean {
      return true
    }
  },
  methods: {
    setVisible(visible: boolean) {
      this.dialogVisible = visible
      this.$emit('update:visible', visible)
      if (!visible) {
        this.reset()
      }
    },
    hide() {
      this.setVisible(false)
    },
    show() {
      this.setVisible(true)
    },
    reset() {
      this.oldPassword = ''
      this.newPassword = ''
      this.newPasswordConfirm = ''
      this.invalidPassword = undefined
      this.v$.$reset()
    },
    async changePassword() {
      const isFormCorrect = await this.v$.$validate()
      if (!isFormCorrect) {
        return
      }

      try {
        await hemisphereService.updatePasswordManual(this.oldPassword, this.newPassword)
        console.log('password change done')
        this.$toast.add({
          severity: 'success',
          summary: 'Mot de passe modifié',
          life: 3000
        })
        this.hide()
      } catch (error) {
        this.invalidPassword = this.oldPassword
        console.log(error)
      }
    }
  }
})
